module.exports = __webpack_public_path__ + "img/fire.cab7e154.gif";